function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent } from "react";
import { injectIntl } from "react-intl";
import Icon from "./Icon";
var DEFAULT_TIMEOUT = 15000;
var NotificationDialog = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(NotificationDialog, PureComponent);
    var _super = _createSuper(NotificationDialog);
    function NotificationDialog(props) {
        _classCallCheck(this, NotificationDialog);
        var _this;
        _this = _super.call(this, props);
        _this.toIds = [];
        _this.toIds = [];
        return _this;
    }
    var _proto = NotificationDialog.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(_) {
        var _this_props = this.props, notifications = _this_props.notifications, dismiss = _this_props.dismiss;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _this = this, _loop = function() {
                var n = _step.value;
                if (!n.error && _this.toIds.indexOf(n.id) === -1) {
                    _this.toIds.push(setTimeout(function() {
                        return dismiss(n.id);
                    }, n.timeout || DEFAULT_TIMEOUT));
                }
            };
            for(var _iterator = notifications[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        for(var i = 0; i < this.toIds.length; i++){
            var to = this.toIds[i];
            if (to) {
                clearTimeout(to);
            }
        }
    };
    _proto.render = function render() {
        var _this_props = this.props, notifications = _this_props.notifications, intl = _this_props.intl, dismiss = _this_props.dismiss, isPreview = _this_props.isPreview;
        return /*#__PURE__*/ React.createElement("div", {
            className: "notifications"
        }, notifications.map(function(n) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "notification-dialog notification-dialog--".concat(n.error ? "error" : n.type),
                key: "notification-" + n.id,
                "data-timeout": n.timeout || DEFAULT_TIMEOUT,
                role: "alert"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "notification-dialog__header"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "notification-dialog__header-text"
            }, n.error ? n.error.name : n.label && n.label && intl.formatMessage({
                id: n.label,
                defaultMessage: n.label
            })), /*#__PURE__*/ React.createElement("button", {
                className: "notification-dialog__btn",
                onClick: function() {
                    return dismiss(n.id);
                },
                "aria-hidden": true
            }, /*#__PURE__*/ React.createElement(Icon, {
                name: "close-line",
                size: "m"
            }))), /*#__PURE__*/ React.createElement("div", {
                className: "notification-dialog__body",
                dangerouslySetInnerHTML: {
                    __html: n.error ? (n.key && n.key === "scorm_error" && isPreview ? intl.formatMessage({
                        id: "errors.scorm_error_creator",
                        defaultMessage: "There is no connection to an LMS. Make sure the CREATOR is open in another browser tab or window to provide that connection."
                    }) : intl.formatMessage({
                        id: "errors.".concat(n.key),
                        defaultMessage: "".concat(n.key, ": ").concat(n.error.message)
                    })) || n.error.message : intl.formatMessage({
                        id: "notifications.".concat(n.message),
                        defaultMessage: n.message
                    }, n.messageProps || {})
                }
            }));
        }));
    };
    return NotificationDialog;
}(PureComponent);
export default injectIntl(NotificationDialog);
